<general-search-panel />

<ng-container *accessView="['HomePage.UI']">
  <ng-container *accessController="[
    'AppealGrievance',
    'OperationsAdmin',
    'Operations',
    'Internal',
    'LetterMapsManager'
  ]">
    @if (queuesEnabled || providerDashboardEnabled || pendingRequestsDashboardEnabled) {
      <div class="sidebar-buttons">
        @if (queuesEnabled) {
          <button
            type="button"
            data-test-id="claim-queue-button"
            [class]="{'active': menu === 'queues' }"
            (click)="goToPage('/home')"
            >
            <i class="pi pi-align-justify"></i>
            Queues
          </button>
        }
        @if (providerDashboardEnabled) {
          <button
            type="button"
            data-test-id="provider-dashboard-button"
            [class.active]="menu === 'pac-provider-dashboard'"
            (click)="goToPacProviderDashboard()"
            >
            <i class="pi pi-th-large"></i>
            Provider Dashboard
          </button>
        }
        @if (pendingRequestsDashboardEnabled) {
          <button
            type="button"
            data-test-id="pending-requests-dashboard-button"
            [class.active]="menu === 'pending-requests-dashboard'"
            (click)="goToPacPendingRequestsDashboard()"
            >
            <i class="pi pi-clock"></i>
            Pending Requests
          </button>
        }
        <ng-container *accessView="['InboundFax.UI.Read']">
          <button
            type="button"
            data-test-id="fax-history-button"
            [class]="{'active': menu === 'inboundfaxes' }"
            (click)="goToPage('/InboundFaxes')"
            >
            <i class="pi pi-inbox"></i>
            Inbound Faxes
          </button>
        </ng-container>
        <div class="menu-separator"></div>
      </div>
    }
  </ng-container>
</ng-container>
@if (showMember) {
  <div class="sidebar-buttons">
    @if (!isExternalUser) {
      <div>
        <button
          type="button"
          data-test-id="member-button"
          [class]="{ 'active': menu === 'member' }"
          (click)="activeMenuClick('member')"
          >
          <i class="pi pi-user"></i>
          Member Details
        </button>
        <button
          type="button"
          data-test-id="member-care-history"
          [class]="{'active': menu === 'memberCareHistory'}"
          (click)="activeMenuClick('memberCareHistory')"
          >
          <i class="pi pi-user"></i>
          Member Care
        </button>
        <div class="menu-separator"></div>
      </div>
    }
    @if (isExternalUser) {
      <div>
        <button
          type="button"
          data-test-id="member-button"
          [class]="{ 'active': menu === 'member' }"
          (click)="activeMenuClick('member')"
          >
          <i class="pi pi-user"></i>
          Member
        </button>
      </div>
    }
    <ng-container *accessView="['AppealsAndGrievances.Read']">
      @if (!isExternalUser) {
        <button
          type="button"
          data-test-id="appeals-button"
          [class]="{ 'active': menu === 'appealsAndGrievances'}"
          (click)="activeMenuClick('appealsAndGrievances')"
          >
          <i class="pi pi-sort-alt icon-rotate"></i>
          Appeals & Grievances
        </button>
      }
    </ng-container>
    <button
      *accessView="['Notes.Read']"
      type="button"
      data-test-id="notes-button"
      [class]="{ 'active': menu === 'notesWidget' }"
      (click)="activeMenuClick('notesWidget')"
      >
      <i class="pi pi-file"></i>
      Notes
    </button>
    @if (isWoundManagementEnabled) {
      <ng-container *accessView="['WoundOstomyAdmission.Read']">
        <button
          type="button" data-test-id="wound-management-button" [class]="{'active': menu === 'wound-management' }"
          (click)="activeMenuClick('wound-management')"
          >
          <i class="pi pi-briefcase"></i>
          Wound Care Connect
        </button>
      </ng-container>
    }
  </div>
}
@if (showFullSideNav) {
  <div class="fullSideNav sidebar-buttons">
    @if (!isExternalUser) {
      <div>
        <button
          type="button"
          data-test-id="member-button"
          [class]="{ 'active': menu === 'member' }"
          (click)="activeMenuClick('member')"
          >
          <i class="pi pi-user"></i>
          Member Details
        </button>
        <button
          type="button"
          data-test-id="member-care-history"
          [class]="{'active': menu === 'memberCareHistory'}"
          (click)="activeMenuClick('memberCareHistory')"
          >
          <i class="pi pi-user"></i>
          Member Care
        </button>
        <div class="menu-separator"></div>
      </div>
    }
    @if (isExternalUser) {
      <div>
        <button
          type="button"
          data-test-id="member-button"
          [class]="{ 'active': menu === 'member' }"
          (click)="activeMenuClick('member')"
          >
          <i class="pi pi-user"></i>
          Member
        </button>
      </div>
    }
    <ng-container *accessView="['AppealsAndGrievances.Read']">
      @if (!isExternalUser) {
        <button
          type="button"
          data-test-id="appeals-button"
          [class]="{'active': menu === 'appealsAndGrievances'}"
          (click)="activeMenuClick('appealsAndGrievances')"
          >
          <i class="pi pi-sort-alt icon-rotate"></i>
          Appeals & Grievances
        </button>
      }
    </ng-container>
    <ng-container *accessView="['Notes.Read']">
      <button
        type="button"
        data-test-id="notes-button"
        [class]="{ 'active': menu === 'notesWidget' }"
        (click)="activeMenuClick('notesWidget')"
        >
        <i class="pi pi-file"></i>
        Notes
      </button>
    </ng-container>
    @if (isWoundManagementEnabled) {
      <ng-container *accessView="['WoundOstomyAdmission.Read']">
        @if (!showDmeposButtons) {
          <button
            type="button"
            data-test-id="wound-management-button"
            [class]="{'active': menu === 'wound-management' }"
            (click)="activeMenuClick('wound-management')"
            >
            <i class="pi pi-briefcase"></i>
            Wound Care Connect
          </button>
        }
      </ng-container>
    }
    @if (showHHButtons) {
      <button
        type="button"
        data-test-id="auth-details-button"
        [class]="{ 'active': menu === 'authorizations' }"
        (click)="activeMenuClick('authorizations')"
        >
        <i class="pi pi-id-card"></i>
        Authorization Details
      </button>
    }
    @if (showPacButtons) {
      <button
        type="button"
        data-test-id="auth-details-button"
        [class]="{ 'active': menu === 'auth-details' }"
        (click)="activeMenuClick('auth-details')"
        >
        <i class="pi pi-id-card"></i>
        Authorization Details
      </button>
    }
    @if (showDmeposButtons) {
      <button
        type="button"
        data-test-id="auth-details-button"
        [class]="{ 'active': menu === 'authorization' }"
        (click)="activeMenuClick('authorization')"
        >
        <i class="pi pi-id-card"></i>
        Authorization Details
      </button>
    }
    @if (showHHButtons) {
      <ng-container *accessView="['AuthorizationServiceLine.Read']">
        <button
          type="button" data-test-id="services-button"
          [class]="{'active': menu === 'serviceline' }"
          (click)="activeMenuClick('serviceline')"
          >
          <i class="pi pi-calendar"></i>
          Services
        </button>
      </ng-container>
    }
    @if (showHHButtons && isHHAutomationEnabled) {
      <ng-container *accessView="['HHClinicalResponses.Read']">
        <button
          type="button"
          [class]="{ 'active': menu === 'clinicalResponsesHH' }"
          (click)="activeMenuClick('clinicalResponsesHH')"
          >
          <i class="pi pi-comment"></i>
          Clinical Responses
        </button>
      </ng-container>
    }
    @if (showHHButtons) {
      <ng-container *accessView="['ServiceProvider.Read']">
        <button
          type="button"
          data-test-id="service-provider-button"
          [class]="{'active': menu === 'provider' }"
          (click)="activeMenuClick('provider')"
          >
          <i class="pi pi-calendar"></i>
          Service Provider
        </button>
      </ng-container>
    }
    @if (showPacButtons) {
      <ng-container *accessView="['PACIMServiceLineSummary.Read']">
        <button
          type="button"
          data-test-id="services-button"
          [class]="{'active': menu === 'service-lines-pacim' }"
          (click)="activeMenuClick('service-lines-pacim')"
          >
          <i class="pi pi-calendar"></i>
          Services
        </button>
      </ng-container>
    }
    @if (showPacMAButtons && isAuthEligible) {
      <ng-container *accessView="['PACIMAnalyticsResponse.Read']">
        <button
          type="button"
          [class]="{ 'active': menu === 'clinicalResponses' }"
          (click)="activeMenuClick('clinicalResponses')"
          >
          <i class="pi pi-comment"></i>
          Clinical Responses
        </button>
      </ng-container>
    }
    @if (showPacButtons) {
      <ng-container *accessView="['PACIMServicingProvider.Read']">
        <button
          type="button"
          data-test-id="servicing-facility-button"
          [class]="{'active': menu === 'servicing-facility-pacim' }"
          (click)="activeMenuClick('servicing-facility-pacim')"
          >
          <i class="pi pi-briefcase"></i>
          Servicing Facility
        </button>
      </ng-container>
    }
    @if (showDmeposButtons) {
      <button
        type="button"
        data-test-id="product-cases-button"
        [class]="{'active': menu === 'productCases' }"
        (click)="activeMenuClick('productCases')"
        >
        <i class="pi pi-briefcase"></i>
        {{ isExternalUser ? 'Product Lines' : 'Product Cases'}}
      </button>
    }
    @if (showDmeposButtons) {
      <button
        type="button"
        data-test-id="service-provider-dme-button"
        (click)="activeMenuClick('servicingProvider')"
        [class]="{'active': menu === 'servicingProvider' }"
        >
        <i class="pi pi-briefcase"></i>
        DMEPOS Provider
      </button>
    }
    @if (showHHButtons) {
      <ng-container *accessView="['OrderingProvider.Read']">
        <button
          type="button"
          data-test-id="ordering-provider-button"
          [class]="{'active': menu === 'orderingPhysician' }"
          (click)="activeMenuClick('orderingPhysician')"
          >
          <i class="pi pi-user"></i>
          Ordering Provider
        </button>
      </ng-container>
    }
    @if (showPacButtons) {
      <ng-container *accessView="['PACIMOrderingProvider.Read']">
        <button
          type="button"
          data-test-id="ordering-provider-button"
          (click)="activeMenuClick('ordering-provider-pacim')"
          [class]="{'active': menu === 'ordering-provider-pacim' }"
          >
          <i class="pi pi-user"></i>
          Ordering Provider
        </button>
      </ng-container>
    }
    @if (showDmeposButtons) {
      <button
        type="button"
        data-test-id="ordering-provider-button"
        (click)="activeMenuClick('orderingProvider')"
        [class]="{'active': menu === 'orderingProvider' }"
        >
        <i class="pi pi-user"></i>
        Ordering Provider
      </button>
    }
    @if (showHHButtons) {
      <ng-container *accessView="['FollowingProvider.Read']">
        <button
          type="button"
          data-test-id="following-provider-button"
          [class]="{'active': menu === 'followingPhysician' }"
          (click)="activeMenuClick('followingPhysician')"
          >
          <i class="pi pi-user"></i>
          Following Provider
        </button>
      </ng-container>
    }
    @if (showPacButtons) {
      <ng-container *accessView="['PACIMAttendingProvider.Read']">
        <button
          type="button"
          data-test-id="attending-provider-button"
          (click)="activeMenuClick('attending-provider-pacim')"
          [class]="{'active': menu === 'attending-provider-pacim' }"
          >
          <i class="pi pi-user"></i>
          Attending Provider
        </button>
      </ng-container>
    }
    @if (showHHButtons) {
      <ng-container *accessView="['Oasis.Read']">
        @if (!isExternalUser) {
          <button
            type="button"
            data-test-id="oasis-button"
            [class]="{'active': menu === 'oasis' }"
            (click)="activeMenuClick('oasis')"
            >
            <i class="pi pi-briefcase"></i>
            Oasis
          </button>
        }
      </ng-container>
    }
    <ng-container *accessView="['FaxDocument.Read', 'PACIMDocuments.Read', 'DMEPOSDocuments.Read']">
      <button
        type="button" data-test-id="documents-button"
        (click)="activeMenuClick('faxdocs')"
        [class]="{'active': menu === 'faxdocs' }"
        >
        <!-- This section has been renamed to Documents as part of PACIM changes. The menu section for 'type' will stay 'faxdocs' to not interrupt other functionality. -->
        <i class="pi pi-folder-open"></i>
        Documents
      </button>
    </ng-container>
    @if (showHHButtons) {
      <ng-container *accessView="['LetterLog.Read']">
        @if (!isExternalUser) {
          <button
            type="button"
            data-test-id="letter-log-button"
            (click)="activeMenuClick('letterLog')"
            [class]="{'active': menu === 'letterLog' }"
            >
            <i class="pi pi-envelope"></i>
            Letter Log
          </button>
        }
      </ng-container>
    }
    @if (showPacButtons) {
      <ng-container *accessView="['PACIMLetterLog.Read']">
        @if (!isExternalUser) {
          <button
            type="button"
            data-test-id="letter-log-button"
            [class]="{'active': menu === 'letter-log-pacim' }"
            (click)="activeMenuClick('letter-log-pacim')"
            >
            <i class="pi pi-envelope"></i>
            Letter Log
          </button>
        }
      </ng-container>
    }
    @if (showDmeposButtons) {
      <ng-container *accessView="['DMEPOSLetterLog.Read']">
        @if (!isExternalUser) {
          <button
            type="button" data-test-id="letter-log-button"
            [class]="{'active': menu === 'letterLog' }"
            (click)="activeMenuClick('letterLog')"
            >
            <i class="pi pi-envelope"></i>
            Letter Log
          </button>
        }
      </ng-container>
    }
    <ng-container *accessView="['AuthSummaryReport.Read']">
      <button
        type="button" data-test-id="auth-summary-button" (click)="activeMenuClick('reports')"
        [class]="{'active': menu === 'reports' }"
        >
        <i class="pi pi-file"></i>
        Auth Summary Report
      </button>
    </ng-container>
    <div class="menu-separator"></div>
  </div>
}
<div class="sidebar-buttons">
  <ng-container *accessController="[
    'AppealGrievance',
    'OperationsAdmin',
    'Operations',
    'Internal',
    'LetterMapsManager'
  ]">
    <ng-container *accessView="['AuthorizationHistoryPage.UI']">
      @if (!isExternalUser) {
        <button
          type="button" data-test-id="auth-history-button"
          [class]="{'active': menu === 'authorizationshistory' }"
          [disabled]="activeTenantId === TenantEmptyValue"
          (click)="goToPageWithTenantId('AuthorizationsViewList')"
          >
            <i class="pi pi-book"></i>
            Authorization History
        </button>
      }
    </ng-container>
    <ng-container *accessView="['FaxHistoryPage.UI']">
      @if (!isExternalUser) {
        <button
          type="button"
          data-test-id="fax-history-button"
          [class]="{'active': menu === 'faxhistory' }"
          (click)="goToPage('/FaxHistory')"
          >
          <i class="pi pi-print"></i>
          Fax History
        </button>
      }
    </ng-container>
    <ng-container *accessView="['ActivityCenterPage.UI']">
      @if (!isExternalUser) {
        <button
          type="button" data-test-id="activity-center-button"
          [class]="{'active': menu === 'activecenter' }"
          (click)="goToPage('activity-center')"
          >
          <i class="pi pi-bell"></i>
          Activity Center
        </button>
      }
    </ng-container>
  </ng-container>
</div>
<div class="sidebar-buttons">
  <ng-container *accessView="['AdminPage.UI']">
    <button
      type="button" data-test-id="admin-button"
      (click)="gotoAdminPanel()"
      [class]="{'active': menu === 'adminpanel' }"
      >
      <i class="pi pi-shield"></i>
      Admin
    </button>
  </ng-container>
</div>
@if (showFullSideNav && isExternalUser) {
  <p-message
    severity="info"
    text="If uploading additional information, select Documents to upload all files."
    styleClass="mr-2"
    class="info-message"
  ></p-message>
}
